module.exports = __webpack_public_path__ + "media/solution.4f80a3aa.mp4";